import {
  getPreviousEditions,
  PreviousEditionsRequestParams,
} from "@/requests/questionnaries/previous-editions.request";
import { useQuery } from "@tanstack/react-query";

export const buildPreviousEditionsQueryKey = (
  params: PreviousEditionsRequestParams,
) => ["companies", params.companyId, "previous-editions"];

export const usePreviousEditions = (
  variables: PreviousEditionsRequestParams,
) => {
  return useQuery({
    queryKey: [
      ...buildPreviousEditionsQueryKey(variables),
      {
        editionName: variables.editionName,
        resultStatus: variables.resultStatus,
        page: variables.page,
        size: variables.size,
        sort: variables.sort,
      },
    ],
    queryFn: () => getPreviousEditions(variables),
    enabled: Boolean(variables.companyId),
  });
};
